import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./OrganizationFeatureUIHelpers";

const OrganizationFeatureUIContext = createContext();

export function useOrganizationFeatureUIContext() {
  return useContext(OrganizationFeatureUIContext);
}

export const OrganizationFeatureUIConsumer =
  OrganizationFeatureUIContext.Consumer;

export function OrganizationFeatureUIProvider({
  organizationFeatureUIEvents,
  children
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initOrganizationFeature = {
    name: ""
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initOrganizationFeature,
    openEditOrganizationFeaturePage:
      organizationFeatureUIEvents.openEditOrganizationFeaturePage
  };

  return (
    <OrganizationFeatureUIContext.Provider value={value}>
      {children}
    </OrganizationFeatureUIContext.Provider>
  );
}
